import {
  ApplicationEventBus,
  StandardEvents,
} from '@upside/spa-shared-context';

import { i18n } from 'i18n';

export function getLogoUrl(themeName: string, darkMode?: boolean) {
  return `/assets/shared/${themeName}/${darkMode ? 'dark/logo' : 'logo'}.svg`;
}

export async function changeLanguage(
  eventBus: ApplicationEventBus | undefined,
  id: string,
) {
  eventBus?.emit(StandardEvents.ChangeLanguage, id);
  await i18n.changeLanguage(id);
}
